import moment from 'moment'
import 'moment-timezone'

const apiHelper = {
  methods: {
    /**
     * Devuelve una fecha en el formato que entiende la API Java
     *
     * Este parámetro se adecua a un tipo de datos Java.util.Date. NO TIENE HORA
     *
     * Devuelve un string en formato YYYY-MM-DD con la zona horaria de Buenos Aires
     *
     * @param {Date|string|moment} fecha
     * @param {Object} args
     * @param {string} args.timezone
     * @param {string} args.format
     *
     * @returns string
     */
    paramFechaApi(fecha, args = {}) {
      if (!fecha) return ''

      const timezone = args?.timezone || 'America/Argentina/Buenos_Aires'
      const format = args?.format || 'YYYY-MM-DD'

      return moment.tz(fecha, timezone).format(format)
    },

    /**
     * Devuelve una fecha+hora+zona horaria en el formato que entiende la API Java
     *
     * Este parámetro se adecua a un tipo de datos Java.util.Date.
     *
     * Ejemplo: "2021-01-12T13:14:28.000+00:00"     *
     *
     * @param {Date|string|moment} fecha
     * @param {Object} args
     * @param {string} args.timezone
     * @param {string} args.format
     *
     * @returns string
     */
    paramFechaHoraApi(fecha, args = {}) {
      const timezone = args?.timezone || 'America/Argentina/Buenos_Aires'
      const format = args?.format || 'YYYY-MM-DD[T]HH:mm:ss'

      return moment.tz(fecha, timezone).format(format)
    },

    /**
     * Devuelve un objeto {Moment} parseando un atributo de tipo fecha según como lo devuelve la API Java
     *
     * Las fechas que devuelve la API Java hay que interpretarlas en UTC
     *
     * @param {Date|string|moment} fecha
     * @param {string} timezone
     * @param {string} format
     *
     * @returns Moment
     */
    valueFechaApi(value, timezone = 'UTC') {
      return moment.tz(value, timezone)
    },
  },
}

export default apiHelper
